import {getCssSize} from 'platform/foundation';
import styled from 'styled-components';

export const OverviewRowButton = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: ${getCssSize(1)} ${getCssSize(2)};
  border-radius: ${({theme}) => theme.radii.small};
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    background: ${({theme}) => theme.colors.palettes.neutral[30][100]};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
